import home from './src/home.vue'
import OpinionHotWords from './src/OpinionManager/OpinionHotWords.vue' //舆情热词
import OpinionMedia from './src/OpinionManager/OpinionMedia.vue' //活跃媒体TOP5
import OpinionTopics from './src/OpinionManager/OpinionTopics.vue' //最新舆情
import OpinionRealTime from './src/OpinionManager/OpinionRealTime.vue' //实时舆情走势
import OpinionAnalysisManager from './src/OpinionManager/OpinionAnalysisManager.vue' //实时舆情走势
import OpinionScoreView from './src/OpinionManager/OpinionScoreView.vue' //舆情评分页面
let views = {
    home,
    OpinionHotWords,
    OpinionMedia,
    OpinionTopics,
    OpinionRealTime,
    OpinionAnalysisManager,
    OpinionScoreView
};

export default views;